import { detailPath } from './paths';

function normalizeSitePath(path) {
  const raw = String(path || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  return raw.startsWith('/') ? raw : `/${raw}`;
}

function resolvePublicImage(ogImage, posterUrl, siteUrl) {
  const raw = String(ogImage || '').trim();
  if (raw) {
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.startsWith('//')) return `https:${raw}`;
    if (raw.startsWith('/')) return `${siteUrl}${raw}`;
    return raw;
  }
  return posterUrl || '';
}

export function buildMediaSeo({
  hero,
  category,
  baseId,
  regionPrefix = '',
  pathSuffix = '',
  fallbackTitleSuffix = '',
  fallbackDescription = '',
  siteUrl = '',
  similarSeo,
}) {
  const useSimilar = pathSuffix === '/similar' && similarSeo && String(similarSeo.metaTitle || '').trim();
  const seo = useSimilar ? similarSeo : hero?.seo || {};
  const title = hero?.title || `#${baseId}`;
  const slugOverride = seo.slug || '';
  const pathBase = detailPath(category, baseId, title, regionPrefix, slugOverride);
  const computedPath = pathSuffix ? `${pathBase}${pathSuffix}` : pathBase;
  const canonicalPath = normalizeSitePath(seo.canonicalPath);
  const path = canonicalPath && !/^https?:\/\//i.test(canonicalPath)
    ? `${canonicalPath}${pathSuffix && !canonicalPath.endsWith(pathSuffix) ? pathSuffix : ''}`
    : computedPath;

  const pageTitle =
    seo.metaTitle || (fallbackTitleSuffix ? `${title} - ${fallbackTitleSuffix}` : title);
  const description =
    seo.metaDescription ||
    (useSimilar ? String(seo.content || '').trim() : '') ||
    hero?.overview ||
    fallbackDescription ||
    '';
  const keywords = Array.isArray(seo.keywords) ? seo.keywords : [];
  const noindex = /noindex/i.test(String(seo.robots || ''));
  const site = String(siteUrl || '').replace(/\/+$/, '');
  const image = resolvePublicImage(seo.ogImage, hero?.posterUrl, site);
  const canonicalOverride = /^https?:\/\//i.test(canonicalPath) ? canonicalPath : '';
  const hreflangAlternates = Array.isArray(seo.hreflangAlternates) ? seo.hreflangAlternates : [];

  return {
    path,
    canonicalOverride,
    title: pageTitle,
    description,
    keywords,
    noindex,
    image,
    hreflangAlternates,
  };
}
